<div class="modal-container">
  <div mat-dialog-title>
    <div class="modal__header">
      <div class="modal__title">
        <h1>Define Ratecard Meta-Structure</h1>
      </div>
      <div class="mt-2"><span>Define the default meta-structure for new ratecards</span></div>
      <button
        class="close-button"
        mat-dialog-close>
        <i class="material-symbols-rounded">close</i>
      </button>
    </div>
  </div>

  <mat-dialog-content aria-label="Add question modal">
    <div class="modal__body flex flex-1 flex-col gap-4 w-full">
      <p class="font-bold">Ratecard Role Meta-structure:</p>
      <p>Additional fields (Max. fields: {{ fields.length }}/{{ MAX_FIELDS }})</p>

      <div
        *ngIf="!(isLoading$ | async); else loader"
        class="ratecard-fields">
        <div
          *ngFor="let field of fields"
          class="ratecard-fields-block"
          (click)="updateField($event, field)">
          <p *ngIf="editFieldNumber != field.order">
            {{ field?.name }}
          </p>
          <scope-ui-input
            *ngIf="editFieldNumber === field.order"
            class="edit-name"
            (click)="$event.stopPropagation()"
            [initialValue]="field.name"
            [autofocus]="true"
            (onInputBlurChange)="saveField($event, field)" />

          <div
            *ngIf="editFieldNumber != field.order"
            class="ratecard-fields-actions">
            <mat-icon
              (click)="updateField($event, field)"
              class="material-symbols-rounded fill orange text-base ml-1.5 pointer">
              mode_edit
            </mat-icon>
            <mat-icon
              (click)="deleteField($event, field)"
              class="material-symbols-rounded fill orange text-base ml-1.5 pointer">
              delete
            </mat-icon>
          </div>
        </div>

        <button
          *ngIf="fields.length < MAX_FIELDS"
          (click)="addField()"
          mat-button>
          <mat-icon class="material-symbols-rounded">add</mat-icon>
          Add field
        </button>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="flex gap-2 justify-end">
    <button
      mat-button
      mat-dialog-close>
      Cancel
    </button>
    <button
      (click)="saveFields()"
      mat-flat-button
      class="ml-8">
      Save
    </button>
  </mat-dialog-actions>
</div>

<ng-template #loader>
  <div class="ratecard-fields-loader">
    <img
      src="https://s3-eu-west-1.amazonaws.com/scopetrackermediastatic/main_load_spinner.gif"
      alt="" />
  </div>
</ng-template>
